<template>
  <div class="customer-registration">
    <HeroBanner
        :background-image="bannerImage"
        title="AS 안심 서비스 조회"
        sub-title="다비치 히어링 보청기는<br>
        검수 과정에서 엄격한 품질 관리를 거쳤으며<br>
        판매하는 모든 보청기는<br>
        고객의 만족과 신뢰성을 최우선으로 합니다."
    />

    <div class="consultation-content">
      <!-- ========== 정품 등록 폼 ========== -->
<!--      <div class="section-header">-->
<!--        <h2 class="section-title">정품 인증</h2>-->
<!--      </div>-->
<!--      <form class="consultation-form" @submit.prevent="submitRegistration">-->
<!--        &lt;!&ndash; 가맹점 코드 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-store-code" class="form-label">-->
<!--            가맹점 코드<span class="required">*</span>-->
<!--          </label>-->
<!--          <input-->
<!--              type="text"-->
<!--              id="reg-store-code"-->
<!--              v-model="registrationForm.storeCode"-->
<!--              @blur="lookupStoreByCode"-->
<!--              @keyup.enter="lookupStoreByCode"-->
<!--              @keydown.enter.prevent-->
<!--              placeholder="코드를 입력해주세요"-->
<!--              maxlength="4"-->
<!--              class="form-input"-->
<!--          />-->
<!--        </div>-->

<!--        &lt;!&ndash; 가맹점 명 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-store-name" class="form-label">-->
<!--            가맹점 명<span class="required">*</span>-->
<!--          </label>-->
<!--          <input-->
<!--              type="text"-->
<!--              id="reg-store-name"-->
<!--              v-model="registrationForm.storeName"-->
<!--              :placeholder="storeNamePlaceholder"-->
<!--              readonly-->
<!--              class="form-input"-->
<!--          />-->
<!--        </div>-->

<!--        &lt;!&ndash; 보청기 브랜드 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-hearing-aid-brand" class="form-label">-->
<!--            보청기 브랜드<span class="required">*</span>-->
<!--          </label>-->
<!--          <select-->
<!--              id="reg-hearing-aid-brand"-->
<!--              v-model="registrationForm.hearingAidBrand"-->
<!--              class="form-select"-->
<!--              :disabled="brandsLoading"-->
<!--          >-->
<!--            <option value="" disabled>-->
<!--              {{ brandsLoading ? '브랜드 로딩 중...' : '브랜드를 선택해주세요' }}-->
<!--            </option>-->
<!--            <option-->
<!--                v-for="brand in brandOptions"-->
<!--                :key="brand.value"-->
<!--                :value="brand.value"-->
<!--            >-->
<!--              {{ brand.label }}-->
<!--            </option>-->
<!--          </select>-->
<!--        </div>-->

<!--        &lt;!&ndash; 보장구 여부 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label class="form-label">-->
<!--            보장구 여부<span class="required">*</span>-->
<!--          </label>-->
<!--          <div class="radio-group">-->
<!--            <div class="radio-item">-->
<!--              <input-->
<!--                  type="radio"-->
<!--                  id="reg-assistive-device-y"-->
<!--                  value="해당"-->
<!--                  v-model="registrationForm.assistiveDeviceType"-->
<!--              />-->
<!--              <label for="reg-assistive-device-y">해당</label>-->
<!--            </div>-->
<!--            <div class="radio-item">-->
<!--              <input-->
<!--                  type="radio"-->
<!--                  id="reg-assistive-device-n"-->
<!--                  value="미해당"-->
<!--                  v-model="registrationForm.assistiveDeviceType"-->
<!--              />-->
<!--              <label for="reg-assistive-device-n">미해당</label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; 보청기 방향 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label class="form-label">-->
<!--            보청기 방향<span class="required">*</span>-->
<!--          </label>-->
<!--          <div class="radio-group">-->
<!--            <div class="radio-item">-->
<!--              <input-->
<!--                  type="radio"-->
<!--                  id="reg-both"-->
<!--                  value="양측"-->
<!--                  v-model="registrationForm.hearingAidDirection"-->
<!--              />-->
<!--              <label for="reg-both">양측</label>-->
<!--            </div>-->
<!--            <div class="radio-item">-->
<!--              <input-->
<!--                  type="radio"-->
<!--                  id="reg-left"-->
<!--                  value="왼쪽"-->
<!--                  v-model="registrationForm.hearingAidDirection"-->
<!--              />-->
<!--              <label for="reg-left">왼쪽</label>-->
<!--            </div>-->
<!--            <div class="radio-item">-->
<!--              <input-->
<!--                  type="radio"-->
<!--                  id="reg-right"-->
<!--                  value="오른쪽"-->
<!--                  v-model="registrationForm.hearingAidDirection"-->
<!--              />-->
<!--              <label for="reg-right">오른쪽</label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; 모델명 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-hearing-aid-model" class="form-label">-->
<!--            모델명<span class="required">*</span>-->
<!--          </label>-->
<!--          <input-->
<!--              type="text"-->
<!--              id="reg-hearing-aid-model"-->
<!--              v-model="registrationForm.hearingAidModel"-->
<!--              @keydown.enter.prevent-->
<!--              placeholder="모델명을 정확하게 입력해주세요"-->
<!--              maxlength="20"-->
<!--              class="form-input"-->
<!--          />-->
<!--        </div>-->

<!--        &lt;!&ndash; 고객명 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-customer-name" class="form-label">-->
<!--            고객명<span class="required">*</span>-->
<!--          </label>-->
<!--          <input-->
<!--              type="text"-->
<!--              id="reg-customer-name"-->
<!--              v-model="registrationForm.customerName"-->
<!--              @keydown.enter.prevent-->
<!--              placeholder="성함을 입력해주세요"-->
<!--              maxlength="20"-->
<!--              class="form-input"-->
<!--          />-->
<!--        </div>-->

<!--        &lt;!&ndash; 구매일자 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-buy-date" class="form-label">-->
<!--            구매일자<span class="required">*</span>-->
<!--          </label>-->
<!--          <input-->
<!--              type="text"-->
<!--              id="reg-buy-date"-->
<!--              v-model="registrationForm.buyDate"-->
<!--              @input="formatDateInput($event, 'buyDate')"-->
<!--              @keydown.enter.prevent-->
<!--              placeholder="년-월-일"-->
<!--              maxlength="10"-->
<!--              class="form-input"-->
<!--          />-->
<!--        </div>-->

<!--        &lt;!&ndash; 보증만료 날짜 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-warranty-expiration-date" class="form-label">-->
<!--            보증만료 날짜<span class="required">*</span>-->
<!--          </label>-->
<!--          <input-->
<!--              type="text"-->
<!--              id="reg-warranty-expiration-date"-->
<!--              v-model="registrationForm.warrantyExpirationDate"-->
<!--              @keydown.enter.prevent-->
<!--              placeholder="구매일자를 입력해주세요"-->
<!--              maxlength="10"-->
<!--              readonly-->
<!--              class="form-input"-->
<!--          />-->
<!--        </div>-->

<!--        &lt;!&ndash; 정품 인증 코드 &ndash;&gt;-->
<!--        <div class="form-group">-->
<!--          <label for="reg-product-auth-code" class="form-label">-->
<!--            인증코드<span class="required">*</span>-->
<!--          </label>-->
<!--          <div>-->
<!--            <div class="form__code">-->
<!--              <span>DH-</span>-->
<!--              <input-->
<!--                  type="text"-->
<!--                  id="reg-product-auth-code"-->
<!--                  v-model="registrationForm.productAuthCode"-->
<!--                  @keydown.enter.prevent-->
<!--                  placeholder="인증코드 입력"-->
<!--                  maxlength="20"-->
<!--                  class="form-input"-->
<!--              />-->
<!--            </div>-->
<!--            <button type="button" @click="checkRegistrationAuthCode" class="submit-button">-->
<!--              정품등록 코드 체크-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; 제출 버튼 &ndash;&gt;-->
<!--        <button type="submit" class="submit-button sky-blue">-->
<!--          정품 등록하기-->
<!--        </button>-->
<!--      </form>-->

      <!-- ========== AS 안심 서비스 조회 폼 ========== -->
      <div class="section-header">
        <h2 class="section-title">AS 안심 서비스 조회</h2>
      </div>

      <!--
        autocomplete="off" : 외부 사이트에 다녀와 뒤로가기로 복귀할 때
        브라우저가 이전 입력값을 input 에 되살려 놓는 것(폼 값 복원)을 막는다.
      -->
      <form class="consultation-form" autocomplete="off" @submit.prevent="submitInquiry">
        <!-- 고객명 -->
        <div class="form-group">
          <label for="inq-customer-name" class="form-label">
            고객명<span class="required">*</span>
          </label>
          <input
              type="text"
              id="inq-customer-name"
              v-model="inquiryForm.customerName"
              @keydown.enter="onInquiryEnter"
              placeholder="성함을 입력해주세요"
              maxlength="20"
              autocomplete="off"
              class="form-input"
          />
        </div>

        <!-- 인증 코드 -->
        <div class="form-group">
          <label for="inq-product-auth-code" class="form-label">
            인증코드<span class="required">*</span>
          </label>
          <div class="form__code">
            <span>DH-</span>
            <input
                type="text"
                id="inq-product-auth-code"
                v-model="inquiryForm.productAuthCode"
                @keydown.enter="onInquiryEnter"
                placeholder="인증코드 6자리 입력"
                maxlength="6"
                autocomplete="off"
                class="form-input"
            />
          </div>
        </div>

        <!-- 제출 버튼 -->
        <button type="submit" class="submit-button" :disabled="inquiryLoading">
          {{ inquiryLoading ? '조회 중...' : '조회하기' }}
        </button>
      </form>

      <!-- ========== AS 안심 서비스 조회 결과 (하단 inline) ========== -->
      <!--
        영역 고정: 한 번이라도 조회를 시도하면 이 래퍼는 항상 DOM에 유지된다.
        - 조회 중에도 이전 결과를 지우지 않고 위에 로딩 오버레이만 덮어 깜빡임/레이아웃 점프 방지
        - min-height 로 결과/메시지 전환 시 높이 점프 최소화
      -->
      <div v-if="inquiryAttempted" class="inquiry-result-area" :class="{ 'is-loading': inquiryLoading }">
        <div v-if="inquiryResult" class="inquiry-result">
          <dl>
            <!-- 고객명은 조회 대상 확인용이므로 맨 앞·맨 뒤 글자만 남기고 마스킹 (이중길 → 이*길) -->
            <div class="inquiry-result__row"><dt>고객명</dt><dd>{{ maskedInquiryName }}</dd></div>
            <!-- 인증코드는 조회 조건으로 이미 입력한 값이라 결과에서는 표출하지 않음 -->
            <div class="inquiry-result__row"><dt>구매처</dt><dd>{{ inquiryResult.store }}</dd></div>
            <div class="inquiry-result__row"><dt>구매일</dt><dd>{{ inquiryResult.buyDate }}</dd></div>
            <div class="inquiry-result__row"><dt>무상 AS 만료일</dt><dd>{{ inquiryResult.exitDate }}</dd></div>
            <div class="inquiry-result__row"><dt>브랜드</dt><dd>{{ inquiryResult.brand }}</dd></div>
            <div class="inquiry-result__row"><dt>모델명</dt><dd>{{ inquiryResult.model }}</dd></div>
            <div class="inquiry-result__row"><dt>방향</dt><dd>{{ inquiryResult.direction }}</dd></div>
            <!-- 정찰제 판매 등급 (클래식, 노블레스 등). 값 없으면 미노출 -->
            <div class="inquiry-result__row" v-if="inquiryResult.goodsFrame"><dt>등급</dt><dd>{{ inquiryResult.goodsFrame }}</dd></div>
          </dl>
        </div>
        <p v-else-if="inquiryMessage" class="inquiry-message">{{ inquiryMessage }}</p>

        <!-- 조회 중 오버레이 (영역은 유지한 채 위에만 덮음) -->
        <div v-if="inquiryLoading" class="inquiry-result__overlay">조회 중...</div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from "@/assets/images/heros/06-top-img.png";
import bannerBg2x from "@/assets/images/heros/06-top-img@2x.png";
import { sanitizeCustomerName } from "@/utils/consultationUtils";
import {
  getInitialRegistrationFormData,
  getInitialInquiryFormData,
  validateRegistrationForm,
  validateInquiryForm,
  sanitizeAuthCode,
  maskCustomerName
} from "@/utils/registrationUtils";
import { mapState } from "vuex";
import axios from "@/api/axios-auth";
import { fetchRegisterBrands, fetchCertificateInquiry } from "@/api";

export default {
  name: 'CustomerRegistration',
  components: { HeroBanner },

  data() {
    return {
      bannerImage: [bannerBg, bannerBg2x],
      registrationForm: getInitialRegistrationFormData(),
      inquiryForm: getInitialInquiryFormData(),
      storeNamePlaceholder: '코드를 입력해주세요',
      brandOptions: [],
      brandsLoading: false,
      isAuthCodeChecked: false,  // 정품 인증 코드 체크 완료 여부
      // AS 안심 서비스 조회(이카스) 상태
      inquiryResult: null,    // 성공 시 8필드 결과
      inquiryMessage: '',     // 없음/오류 메시지
      inquiryLoading: false,  // 조회 중(중복 클릭 차단)
      inquiryAttempted: false, // 한 번이라도 조회를 시도했는지 (결과 영역 고정용)
      inquiryCache: {}        // 동일 조건 재조회 캐시 { 'name|code': { result, message } }
    };
  },

  async created() {
    await this.loadBrands();
  },

  mounted() {
    // 외부 사이트에 다녀와 뒤로가기로 돌아온 경우 조회 영역을 초기 상태로 되돌린다.
    // pageshow 는 bfcache 복원(persisted=true)과 일반 재생성 양쪽 모두에서 발생한다.
    this.resetInquiry();
    window.addEventListener('pageshow', this.resetInquiry);
  },

  beforeDestroy() {
    window.removeEventListener('pageshow', this.resetInquiry);
  },

  computed: {
    ...mapState({
      privacyContents: (state) => state.others?.privacy?.[0]?.contents || ''
    }),

    // 조회 결과에 표출할 마스킹된 고객명 (이중길 → 이*길)
    maskedInquiryName() {
      return maskCustomerName(this.inquiryResult && this.inquiryResult.name);
    }
  },

  watch: {
    // 정품 등록 폼 watch
    'registrationForm.storeCode'(value) {
      // 숫자만 입력 가능하도록 제한
      this.registrationForm.storeCode = value.replace(/[^0-9]/g, '');
    },
    'registrationForm.customerName'(value) {
      this.registrationForm.customerName = sanitizeCustomerName(value);
    },
    'registrationForm.productAuthCode'(value) {
      this.registrationForm.productAuthCode = sanitizeAuthCode(value);
      // 인증코드가 변경되면 체크 상태 초기화
      this.isAuthCodeChecked = false;
    },
    'registrationForm.buyDate'(newValue) {
      // 구매일자 변경 시 보증만료 날짜 자동 계산 (구매일 + 2년)
      if (!newValue) {
        // 구매일자가 비어있으면 보증만료 날짜도 초기화
        this.registrationForm.warrantyExpirationDate = '';
        return;
      }

      // YYYY-MM-DD 형식이 완성되었을 때만 계산
      if (newValue.length === 10) {
        const buyDate = new Date(newValue);

        // 유효한 날짜인지 확인
        if (!isNaN(buyDate.getTime())) {
          // 2년 추가
          const warrantyDate = new Date(buyDate);
          warrantyDate.setFullYear(warrantyDate.getFullYear() + 2);

          // YYYY-MM-DD 형식으로 변환
          const year = warrantyDate.getFullYear();
          const month = String(warrantyDate.getMonth() + 1).padStart(2, '0');
          const day = String(warrantyDate.getDate()).padStart(2, '0');

          this.registrationForm.warrantyExpirationDate = `${year}-${month}-${day}`;
        } else {
          // 유효하지 않은 날짜면 초기화
          this.registrationForm.warrantyExpirationDate = '';
        }
      }
    },

    // AS 안심 서비스 조회 폼 watch
    'inquiryForm.customerName'(value) {
      this.inquiryForm.customerName = sanitizeCustomerName(value);
    },
    'inquiryForm.productAuthCode'(value) {
      this.inquiryForm.productAuthCode = sanitizeAuthCode(value);
    }
  },

  methods: {
    /**
     * 보청기 브랜드 목록 조회 (신규 API)
     */
    async loadBrands() {
      if (this.brandsLoading) return;

      this.brandsLoading = true;
      try {
        const response = await fetchRegisterBrands();
        // API 응답: [{ id, name, description? }]
        const brands = response.data;
        
        this.brandOptions = brands.map(brand => ({
          value: brand.name,
          label: brand.name
        }));
      } catch (error) {
        console.error('브랜드 목록 로딩 실패:', error);
        // 사용자에게 안내 (기존 알럿/토스트 정책을 따름)
        // alert('브랜드 정보를 불러오는 중 오류가 발생했습니다.');
        this.brandOptions = [
          {
            value:'렉스톤',
            label:'버나톤'
          },
          {
            value :'스타키',
            label :'스타키'
          },
          {
            value :'시그니아',
            label :'시그니아'
          },
          {
            value :'오티콘',
            label :'오티콘'
          },
          {
            value :'와이덱스',
            label :'와이덱스'
          },
          {
            value :'유니트론',
            label :'유니트론'
          },
          {
            value :'필립스',
            label :'필립스'
          },
          {
            value :'포낙',
            label :'포낙'
          }
        ];
      } finally {
        this.brandsLoading = false;
      }
    },

    /**
     * 가맹점 코드로 구매처 조회
     */
    async lookupStoreByCode() {
      const storeCode = this.registrationForm.storeCode.trim();

      // 가맹점 코드가 비어있으면 조회하지 않음
      if (!storeCode) {
        this.registrationForm.storeName = '';
        this.storeNamePlaceholder = '코드를 입력해주세요';
        return;
      }

      // 4자리가 아니면 조회하지 않음
      if (storeCode.length !== 4) {
        this.registrationForm.storeName = '';
        this.storeNamePlaceholder = '코드를 입력해주세요';
        return;
      }

      try {
        const response = await axios.get('/store/lookup', {
          params: {
            strCode: storeCode
          }
        });

        if (response.data.success) {
          this.registrationForm.storeName = response.data.strName;
          this.storeNamePlaceholder = '코드를 입력해주세요';
        } else {
          this.registrationForm.storeName = '';
          this.storeNamePlaceholder = '일치하는 가맹점 코드가 없습니다';
        }
      } catch (error) {
        console.error('가맹점 코드 조회 오류:', error);
        this.registrationForm.storeName = '';
        if (error.response?.status === 404) {
          this.storeNamePlaceholder = '일치하는 가맹점 코드가 없습니다';
        } else {
          this.storeNamePlaceholder = '가맹점 조회 중 오류가 발생했습니다';
        }
      }
    },

    /**
     * 날짜 입력 포맷팅 (YYYY-MM-DD)
     * 년도 4자리 입력 시 자동으로 - 추가 및 월로 이동
     * 월 2자리 입력 시 자동으로 - 추가 및 일로 이동
     */
    formatDateInput(event, fieldName) {
      let value = event.target.value.replace(/[^\d]/g, ''); // 숫자만 추출
      let formattedValue = '';

      // 년도 (4자리)
      if (value.length > 0) {
        formattedValue = value.substring(0, 4);
      }

      // 월 (2자리) - 년도 4자리 입력 후 자동으로 - 추가
      if (value.length >= 5) {
        formattedValue += '-' + value.substring(4, 6);
      }

      // 일 (2자리) - 월 2자리 입력 후 자동으로 - 추가
      if (value.length >= 7) {
        formattedValue += '-' + value.substring(6, 8);
      }

      // 업데이트
      this.$nextTick(() => {
        this.registrationForm[fieldName] = formattedValue;
      });
    },

    /**
     * 정품 등록 폼 유효성 검사 (포커스 이동 포함)
     */
    validateRegistrationFormWithFocus() {
      const form = this.registrationForm;
      const validations = [
        { field: 'storeCode', id: 'reg-store-code', message: '가맹점 코드를 입력해주세요.', check: () => !form.storeCode.trim() },
        { field: 'storeName', id: 'reg-store-name', message: '가맹점 명을 입력해주세요.', check: () => !form.storeName.trim() },
        { field: 'hearingAidBrand', id: 'reg-hearing-aid-brand', message: '보청기 브랜드를 선택해주세요.', check: () => !form.hearingAidBrand },
        { field: 'hearingAidModel', id: 'reg-hearing-aid-model', message: '모델명을 입력해주세요.', check: () => !form.hearingAidModel.trim() },
        { field: 'customerName', id: 'reg-customer-name', message: '고객명을 입력해주세요.', check: () => !form.customerName.trim() },
        { field: 'buyDate', id: 'reg-buy-date', message: '구매일자를 입력해주세요.', check: () => !form.buyDate },
        { field: 'warrantyExpirationDate', id: 'reg-warranty-expiration-date', message: '보증만료 날짜를 입력해주세요.', check: () => !form.warrantyExpirationDate },
        { field: 'productAuthCode', id: 'reg-product-auth-code', message: '인증코드를 입력해주세요.', check: () => !form.productAuthCode.trim() }
      ];

      // 기본 필수 필드 검증
      for (const validation of validations) {
        if (validation.check()) {
          alert(validation.message);
          this.focusField(validation.id);
          return false;
        }
      }

      // 날짜 형식 및 논리 검증
      if (form.buyDate && form.buyDate.length !== 10) {
        alert('올바른 구매일자 형식으로 입력해주세요. (YYYY-MM-DD)');
        this.focusField('reg-buy-date');
        return false;
      }

      if (form.warrantyExpirationDate && form.warrantyExpirationDate.length !== 10) {
        alert('올바른 보증만료 날짜 형식으로 입력해주세요. (YYYY-MM-DD)');
        this.focusField('reg-warranty-expiration-date');
        return false;
      }

      // 기존 유효성 검사 (날짜 논리 검증 등)
      if (!validateRegistrationForm(form)) {
        // 날짜 관련 에러의 경우 해당 필드로 포커스
        if (form.buyDate && form.warrantyExpirationDate) {
          this.focusField('reg-warranty-expiration-date');
        }
        return false;
      }

      return true;
    },

    /**
     * 특정 필드로 포커스 이동
     */
    focusField(fieldId) {
      this.$nextTick(() => {
        const element = document.getElementById(fieldId);
        if (element) {
          element.focus();
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },

    /**
     * 정품 등록 제출
     */
    async submitRegistration() {
      if (!this.validateRegistrationFormWithFocus()) {
        return;
      }

      // 정품 인증 코드 체크 완료 여부 확인
      if (!this.isAuthCodeChecked) {
        alert('정품등록 코드 체크를 완료해주세요.');
        this.focusField('reg-product-auth-code');
        return;
      }

      try {
        await axios.post('/certificate/register', {
          affiliateCode: this.registrationForm.storeCode,
          affiliate: this.registrationForm.storeName,
          brand: this.registrationForm.hearingAidBrand,
          assist: this.registrationForm.assistiveDeviceType,
          direction: this.registrationForm.hearingAidDirection,
          model: this.registrationForm.hearingAidModel,
          name: this.registrationForm.customerName,
          buyDate: this.registrationForm.buyDate,
          exitDate: this.registrationForm.warrantyExpirationDate,
          servey: null,
          decide_id: this.registrationForm.productAuthCode
        });

        alert('정품 등록이 완료되었습니다.');
        this.registrationForm = getInitialRegistrationFormData();
        this.storeNamePlaceholder = '코드를 입력해주세요';
        this.isAuthCodeChecked = false;  // 폼 초기화 시 체크 상태도 초기화
      } catch (error) {
        console.error('정품 등록 오류:', error);
        console.error('에러 응답:', error.response?.data);
        alert(error.response?.data?.message || '정품 등록 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    },

    /**
     * 정품 인증 코드 체크 (정품 등록)
     *
     * 응답 코드:
     * "1" - 정품 인증 코드가 없음
     * "2" - 중복된 코드 (이미 사용됨)
     * "3" - 사용 가능한 코드
     */
    async checkRegistrationAuthCode() {
      if (!this.registrationForm.productAuthCode.trim()) {
        alert('인증코드를 입력해주세요.');
        return;
      }

      try {
        const response = await axios.get('/certificate/check', {
          params: {
            checkcode: `${this.registrationForm.productAuthCode}`
          }
        });

        const code = response.data.code;

        if (code === "1") {
          alert('정품 인증 코드가 없습니다.');
          this.isAuthCodeChecked = false;
          this.focusField('reg-product-auth-code');
        } else if (code === "2") {
          alert('중복된 코드입니다.');
          this.isAuthCodeChecked = false;
          this.focusField('reg-product-auth-code');
        } else if (code === "3") {
          alert('사용 가능한 코드입니다.');
          this.isAuthCodeChecked = true;  // 코드 체크 완료
        }
      } catch (error) {
        console.error('정품 인증 코드 체크 오류:', error);
        this.isAuthCodeChecked = false;
        alert(error.response?.data?.message || '인증코드 확인 중 오류가 발생했습니다.');
      }
    },

    /**
     * AS 안심 서비스 조회 폼 유효성 검사 (포커스 이동 포함)
     */
    validateInquiryFormWithFocus() {
      const form = this.inquiryForm;

      if (!form.customerName.trim()) {
        alert('고객명을 입력해주세요.');
        this.focusField('inq-customer-name');
        return false;
      }

      if (!form.productAuthCode.trim()) {
        alert('인증코드를 입력해주세요.');
        this.focusField('inq-product-auth-code');
        return false;
      }

      // 기존 유효성 검사 (인증코드 길이 등)
      if (!validateInquiryForm(form)) {
        this.focusField('inq-product-auth-code');
        return false;
      }

      return true;
    },

    /**
     * AS 안심 서비스 조회 제출
     *
     * 고객명과 정품 인증 코드로 등록된 정품 정보를 조회합니다.
     * 일치하는 정보가 있으면 고객명, 가맹점, 구매일, 무상 AS 만료일, 브랜드, 모델을 표시합니다.
     */
    /**
     * 결과/메시지를 한 번에 교체 (깜빡임 방지)
     * - 로딩 시작 시점에 미리 비우지 않고, 값이 확정됐을 때만 원자적으로 교체
     */
    setInquiryOutput(result, message) {
      this.inquiryResult = result;
      this.inquiryMessage = message;
    },

    /**
     * AS 안심 서비스 조회 영역 초기화 (폼 + 결과 + 캐시)
     *
     * 개인정보가 표출되는 영역이므로 페이지에 다시 들어왔을 때는 항상 빈 화면에서 시작한다.
     */
    resetInquiry() {
      this.inquiryForm = getInitialInquiryFormData();
      this.inquiryResult = null;
      this.inquiryMessage = '';
      this.inquiryLoading = false;
      this.inquiryAttempted = false;
      this.inquiryCache = {};

      // Vue 데이터가 이미 빈 값이면 재렌더링이 일어나지 않아,
      // 브라우저가 복원해 둔 input 의 값이 화면에 그대로 남는다.
      // (데이터는 '' 인데 화면에는 글자가 보이는 상태)
      // DOM 값을 직접 비워 데이터와 화면을 맞춘다.
      this.$nextTick(() => {
        ['inq-customer-name', 'inq-product-auth-code'].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.value = '';
        });
      });
    },

    /**
     * 조회 폼에서 Enter 로 제출
     *
     * 한글 IME 조합 중에는 v-model 이 아직 갱신되지 않은 상태다(compositionend 전).
     * 조합을 확정하는 Enter 를 그대로 통과시키면 마지막 글자가 빠진 값으로 조회된다.
     * (예: '홍길동' 의 '동' 조합 중 Enter → '홍길' 으로 조회 → 결과 없음)
     * 따라서 조합 중인 Enter 는 IME 에게 넘기고, 조합이 끝난 Enter 에서만 조회한다.
     */
    onInquiryEnter(event) {
      if (event.isComposing || event.keyCode === 229) return;

      event.preventDefault();   // form 의 기본 제출 차단 (submitInquiry 중복 호출 방지)
      this.submitInquiry();
    },

    async submitInquiry() {
      const name = this.inquiryForm.customerName.trim();
      const code = this.inquiryForm.productAuthCode.trim().toUpperCase();

      // 한 번이라도 시도하면 결과 영역을 고정 노출 (이후 데이터 유무와 무관하게 영역 유지)
      this.inquiryAttempted = true;

      // 검증: 필수 + 정품코드 영숫자 6자 (이름=한글 허용)
      if (!name) {
        this.setInquiryOutput(null, '고객명을 입력해주세요.');
        this.focusField('inq-customer-name');
        return;
      }
      if (!/^[A-Z0-9]{6}$/.test(code)) {
        this.setInquiryOutput(null, '인증코드 6자리를 정확히 입력해주세요.');
        this.focusField('inq-product-auth-code');
        return;
      }

      // 캐시 히트: 동일 고객명+인증코드 재조회는 API 호출 없이 이전 결과 그대로 표출
      // (더블클릭/연타·재검색 시 불필요한 요청 차단)
      const cacheKey = `${name}|${code}`;
      const cached = this.inquiryCache[cacheKey];
      if (cached) {
        this.setInquiryOutput(cached.result, cached.message);
        return;
      }

      if (this.inquiryLoading) return;   // 조회 중(진행 중인 요청) 더블클릭 차단
      this.inquiryLoading = true;
      try {
        const res = await fetchCertificateInquiry({ name, code });
        const data = res.data;

        let result = null;
        let message = '';
        if (data.status === 'ok') {
          result = data.item;                          // 성공: 8필드 inline 표출
        } else if (data.status === 'returned') {
          // 반품 완료 건: 결과 미표출 + 안내 문구
          message = '반품 완료된 상품으로 AS 안심 서비스 조회가 불가합니다.';
        } else if (data.status === 'not_found') {
          message = '일치하는 정품 정보가 없습니다.';
        } else {
          message = '일치하는 정품 정보가 없습니다';     // 그 외 응답
        }

        // 확정 결과(성공/없음/반품)만 캐시 — 일시적 오류는 캐시하지 않아 재시도 가능
        if (data.status === 'ok' || data.status === 'not_found' || data.status === 'returned') {
          this.inquiryCache[cacheKey] = { result, message };
        }
        this.setInquiryOutput(result, message);
      } catch (error) {
        // 서버·네트워크·토큰 오류 모두 사용자에겐 동일 메시지(내부 구분은 서버 로그)
        // 오류는 캐시하지 않음
        console.error('AS 안심 서비스 조회 error :', error);
        this.setInquiryOutput(null, '일치하는 정품 정보가 없습니다');
      } finally {
        this.inquiryLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";

.customer-registration .consultation-content .consultation-form .form-group .form-input[readonly]{
  background: transparent !important;
}

.form__code{
  display: flex;
  align-items: center;
  /* flex 아이템의 기본값 min-width:auto 는 input 의 고유 폭(기본 size=20자) 아래로
     줄어들지 못하게 막는다. 좁은 화면에서 input 이 칸을 넘쳐 placeholder 가 잘리던 원인. */
  min-width: 0;
  span{
    font-size: 22.16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: -0.75px;
    vertical-align: middle;
    margin-right: 10px;
    flex: none;
  }
  input{
    width: 100%;
    min-width: 0;
  }
}

/* 모바일: 'DH-' 접두사가 데스크톱 크기(22.16px) 그대로여서 입력 칸을 잡아먹는다 */
@media (max-width: 768px) {
  .form__code{
    span{
      font-size: 16px;
      margin-right: 6px;
    }
  }
}
@media (max-width: 450px) {
  .form__code{
    input{
      padding-left: 12px;
      padding-right: 12px;
    }
    /* 좁은 폭에서 placeholder 만 한 단계 작게 → 문구가 잘리지 않음 */
    input::placeholder{
      font-size: 14px;
    }
  }
}

/* AS 안심 서비스 조회 결과 (하단 inline) — 히어링 스타일에 맞춰 깔끔하게 */
/* 결과 영역: 항상 자리 유지 → 데이터 유무/조회 중 레이아웃 점프·깜빡임 방지 */
.inquiry-result-area{
  position: relative;
  max-width: 800px;
  min-height: 96px;            /* 메시지↔결과 전환 시 높이 점프 최소화 */
  margin-top: 36px;
}
.inquiry-result-area.is-loading{
  /* 조회 중에는 이전 내용을 살짝 흐리게 두고 위에 오버레이 표시 */
  .inquiry-result, .inquiry-message{ opacity: .45; }
}
/* 영역 내부 요소는 자체 margin-top 제거 (래퍼가 간격 담당) */
.inquiry-result-area .inquiry-result,
.inquiry-result-area .inquiry-message{
  margin-top: 0;
}
.inquiry-result__overlay{
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  font-size: 16px;
  font-weight: 500;
}

.inquiry-result{
  max-width: 800px;
  margin-top: 40px;
  border-top: 2px solid #222;
  dl{ margin: 0; }
  .inquiry-result__row{
    display: flex;
    align-items: center;
    padding: 18px 4px;
    border-bottom: 1px solid #eee;
    dt{
      width: 160px;
      flex: none;
      color: #888;
      font-size: 16px;
      font-weight: 500;
    }
    dd{
      margin: 0;
      color: #222;
      font-size: 18px;
      font-weight: 500;
      /* min-width:auto 해제 — 값이 길어도 dt 를 밀어내며 넘치지 않도록 */
      min-width: 0;
    }
  }
}

/* 태블릿~큰 폰: 2열은 유지하되 라벨 폭을 줄이고 값이 줄바꿈되도록 */
@media (max-width: 768px) {
  .inquiry-result{
    margin-top: 28px;
    .inquiry-result__row{
      padding: 14px 4px;
      align-items: flex-start;   /* 값이 2줄이 되어도 라벨은 첫 줄에 정렬 */
      dt{
        width: 110px;
        font-size: 14px;
        line-height: 1.5;
      }
      dd{
        font-size: 16px;
        line-height: 1.5;
        /* 전역 word-break:keep-all(main.scss) 때문에 공백 없는 매장명이
           통째로 한 덩어리가 되어 칸을 넘쳤다. 이 영역에서만 줄바꿈을 허용한다. */
        word-break: normal;
        overflow-wrap: anywhere;
      }
    }
  }
}

/* 작은 폰: 2열로는 값에 남는 폭이 부족 → 라벨 위 / 값 아래로 세로 배치.
   값이 화면 전체 폭을 쓰므로 매장명이 잘리지도, 어색하게 끊기지도 않는다. */
@media (max-width: 480px) {
  .inquiry-result{
    .inquiry-result__row{
      display: block;
      padding: 12px 4px;
      dt{
        width: auto;
        font-size: 13px;
        margin-bottom: 4px;
      }
      dd{
        font-size: 16px;
        word-break: keep-all;    /* 폭이 넉넉해져 어절 단위 줄바꿈으로 되돌림 */
      }
    }
  }
}
.inquiry-message{
  max-width: 800px;
  margin-top: 36px;
  padding: 28px 0;
  text-align: center;
  color: #888;
  font-size: 18px;
  line-height: 1.6;
  white-space: pre-line;   /* 메시지의 \n 을 줄바꿈으로 표시 */
  border-top: 1px solid #eee;
}
.submit-button:disabled{
  opacity: 0.5;
  cursor: not-allowed;
}
.section-header:nth-of-type(2){
  margin-top: 77px;
}
.customer-registration {
  .consultation-content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 80px 38px 100px;

    .section-header {
      text-align: left;
      margin-bottom: 50px;
      padding-bottom: 20px;
      border-bottom: 2px solid #222;

      .section-title {
        font-size: 32px;
        font-weight: 700;
        color: #222;
      }
    }

    .consultation-form {
      max-width: 800px;

      .form-group {
        //max-height: 88px;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: 1fr 275px;
        display: grid;
        margin-bottom: 24px;
        .form-label {
          display: block;
          font-family: font family/Font 1;
          font-weight: font weight/500;
          font-style: Medium;
          font-size: 20.78px;
          leading-trim: NONE;
          line-height: 41.55px;
          letter-spacing: -0.62px;
          vertical-align: middle;
          .required {
            color: $color-skyblue;
            margin-left: 4px;
          }
        }

        .radio-group {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
          .radio-item {
            display: flex;
            align-items: center;
            justify-content: center;
            input[type="radio"] {
              display: none;
            }
            input[type="radio"]:checked{
              + label{
                color: $color-blue;
                background: #E7F2FFFF;
                //box-shadow: 0 0 0 2px $color-blue inset;
                //border: none;
                font-weight: 600;
                //accent-color: red;
              }
            }
            &:last-child label{
              border-right: 1px solid #222;
            }
            label {
              padding: 32px 0;
              border: 1px solid #222;
              border-right: none;
              //box-shadow: 0 0 0 1px #222 inset;
              //max-width: 92px;
              width: 100%;
              font-family: font family/Font 1;
              font-weight: font weight/500;
              font-style: Medium;
              font-size: 22.16px;
              leading-trim: NONE;
              letter-spacing: -0.62px;
              text-align: center;
              vertical-align: middle;
              cursor: pointer;
              user-select: none;
            }
          }
        }
        .form-input,
        .form-select {
          padding: 16px 20px;
          font-size: 16px;
          border-bottom: 1px solid #ddd;
          font-weight: 350;
          font-size: 22.16px;
          leading-trim: NONE;
          line-height: 100%;
          vertical-align: middle;
          transition: border-color 0.3s;

          &:focus {
            outline: none;
            border-color: $color-blue;
          }

          &::placeholder {
            color: #999;
          }

          &[readonly] {
            background-color: #f5f5f5;
            cursor: not-allowed;
            color: #666;
          }
        }

        .form-input::placeholder{
          color: #ccc;
        }
        .form-select {
          cursor: pointer;
          background-color: white;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23333' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 20px center;
          padding-right: 50px;
        }
      }
      .consent-notice {
        margin: 30px 0;
        padding: 20px;
        //background-color: #f9f9f9;
        border-radius: 4px;
        font-size: 14px;
        line-height: 1.8;
        color: #666;

        font-weight: 350;
        font-size: 20.12px;
        leading-trim: NONE;
        line-height: 33.96px;
        letter-spacing: -0.6px;
        vertical-align: middle;

        p {
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }

          &:first-child {
            font-weight: 600;
            color: #333;
          }
        }
      }

      .submit-button {
        width: 100%;
        padding: 20px;
        font-size: 18px;
        font-weight: 600;
        color: white;
        background-color: $color-blue;
        border: none;
        //border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s;
        &.sky-blue{
          margin-top: 10px;
          background-color: $color-skyblue;
        }
        &:hover {
          background-color: darken($color-blue, 10%);
        }

        &:active {
          background-color: darken($color-blue, 15%);
        }
      }

    }
  }


  @media (max-width: 768px) {
    .consultation-content {
      padding: 50px 20px 60px;
      .section-header {
        margin-bottom: 40px;
        .section-title {
          font-size: 24px;
        }
      }
      .consultation-form {
        .form-group {
          grid-template-columns: 1fr 275px;
          .form-label {
            font-size: 16px;
            margin-bottom: 12px;
          }
          .radio-group {
            .radio-item {
              label {
                font-size: 16px;
              }
            }
          }

          .form-input,
          .form-select {
            padding: 14px 16px;
            font-size: 16px;
          }
        }

        .consent-notice {
          padding: 16px;
          font-size: 13px;
        }

        .submit-button {
          padding: 16px;
          font-size: 16px;
          margin-top: 30px;
        }
      }
    }
  }

  @media (max-width: 450px) {
    .consultation-content {
      .consultation-form {
        .form-group {
          grid-template-columns: 1fr 224px;
        }
      }
    }
  }
}


</style>
